import { Container, Row, Col, Button } from 'react-bootstrap';
import { useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [showContact, setShowContact] = useState(false);

  return (
    <footer className="footer mt-auto py-3" style={{ backgroundColor: '#003d82', color: '#ffffff' }}>
      <Container className="px-3 px-lg-5">
        <Row className="align-items-center">
          <Col className="text-start">
            <span className="footer-text">@KM Rafting Adventures</span>
          </Col>
          <Col className="text-end">
            <span className="footer-text">Created by Fully Connected</span>
            <Button 
              variant="outline-warning" 
              size="sm" 
              className="ms-3 contact-btn"
              onClick={() => setShowContact(!showContact)}
            >
              Contact Info
            </Button>
            {showContact && (
              <div className="contact-info mt-2" style={{ color: '#ffffff' }}>
                <small>Email: info@fullyconnected.co.za for more info</small>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;